import { io } from "socket.io-client";

const socket = io(process.env.REACT_APP_SOCKET_CONNECTION_STRING as string, {
  path: "/api/socket.io/",
});

export default socket;
